module.exports = __webpack_public_path__ + "img/trial4-1.c894905c.png";